/* ============================================================
   product-media-grid.js
   Beteende för det fristående produktgalleriet (.pmg).

   1) Spelar inline-videor (muted + loop + autoplay).
   2) Egen, självständig lightbox (overlay på <body>, hög z-index).
      INGA beroenden på temat eller PhotoSwipe. Kan inte hamna
      bakom innehåll (ligger utanför alla stacking-contexts).
      Pilar, tangentbord (←/→/Esc), swipe, klick på bakgrund stänger.
   3) Hindrar att en swipe på mobil råkar öppna lightboxen.

   Felsökning: sök efter "[pmg]" i konsolen.
   ============================================================ */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  /* ---- Inline-videor: muted (krav för autoplay) + starta ---- */
  function initVideos(root) {
    root.querySelectorAll('.pmg__video').forEach(function (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {});
      }
    });
  }

  /* ---- Delad lightbox (byggs en gång, läggs på <body>) ---- */
  var lb, lbImg, lbCounter, lbPrev, lbNext;
  var items = [];   // [{ src, alt }]
  var index = 0;
  var preloaded = {};

  /* Förladda en bild (per URL) så bläddring blir direkt */
  function preload(i) {
    if (!items.length) return;
    var n = (i + items.length) % items.length;
    var src = items[n].src;
    if (!src || preloaded[src]) return;
    preloaded[src] = true;
    var im = new Image();
    im.src = src;
  }

  function build() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'pmg-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML =
      '<button type="button" class="pmg-lb__close" aria-label="Stäng">&times;</button>' +
      '<button type="button" class="pmg-lb__nav pmg-lb__nav--prev" aria-label="Föregående">&#8249;</button>' +
      '<img class="pmg-lb__img" src="" alt="">' +
      '<button type="button" class="pmg-lb__nav pmg-lb__nav--next" aria-label="Nästa">&#8250;</button>' +
      '<div class="pmg-lb__counter"></div>';
    document.body.appendChild(lb);

    lbImg = lb.querySelector('.pmg-lb__img');
    lbCounter = lb.querySelector('.pmg-lb__counter');
    lbPrev = lb.querySelector('.pmg-lb__nav--prev');
    lbNext = lb.querySelector('.pmg-lb__nav--next');

    lb.querySelector('.pmg-lb__close').addEventListener('click', close);
    lbPrev.addEventListener('click', function (e) { e.stopPropagation(); show(index - 1); });
    lbNext.addEventListener('click', function (e) { e.stopPropagation(); show(index + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
    });

    // Swipe i lightboxen: vänster/höger = bläddra, ner = stäng
    var sx = 0, sy = 0;
    lbImg.addEventListener('touchstart', function (e) {
      if (e.touches && e.touches[0]) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
    }, { passive: true });
    lbImg.addEventListener('touchend', function (e) {
      var t = e.changedTouches && e.changedTouches[0];
      if (!t) return;
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        show(dx < 0 ? index + 1 : index - 1);
      } else if (dy > 60 && Math.abs(dy) > Math.abs(dx)) {
        close();
      }
    }, { passive: true });
  }

  function show(i) {
    if (!items.length) return;
    index = (i + items.length) % items.length; // wrap runt
    lbImg.setAttribute('src', items[index].src);
    lbImg.setAttribute('alt', items[index].alt || '');
    lbCounter.textContent = (index + 1) + ' / ' + items.length;
    var multi = items.length > 1;
    lbPrev.style.display = multi ? '' : 'none';
    lbNext.style.display = multi ? '' : 'none';
    lbCounter.style.display = multi ? '' : 'none';

    // Förladda grannbilderna så nästa/föregående visas direkt
    preload(index + 1);
    preload(index - 1);
  }

  function open(list, i) {
    build();
    items = list;
    show(i);
    lb.classList.add('is-open');
    lb.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    // Förladda hela galleriet i bakgrunden → all bläddring blir direkt
    for (var k = 0; k < items.length; k++) {
      preload(k);
    }
  }

  function close() {
    if (!lb) return;
    lb.classList.remove('is-open');
    lb.setAttribute('aria-hidden', 'true');
    lbImg.setAttribute('src', '');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  /* ---- Per galleri: koppla knappar + swipe-skydd ---- */
  function initGallery(root) {
    if (root.getAttribute('data-zoom') === 'false') return;

    var images = Array.prototype.slice.call(root.querySelectorAll('.pmg__img'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.pmg__zoom'));
    if (!images.length || !buttons.length) return;

    var list = images.map(function (img) {
      return {
        src: img.getAttribute('data-pmg-full') || img.currentSrc || img.src,
        alt: img.getAttribute('alt') || ''
      };
    });

    // Swipe-skydd på mobil-karusellen: öppna inte mitt i en swipe
    var moved = false, sx = 0, sy = 0;
    var track = root.querySelector('.pmg__track');
    if (track) {
      track.addEventListener('touchstart', function (e) {
        if (e.touches && e.touches[0]) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false; }
      }, { passive: true });
      track.addEventListener('touchmove', function (e) {
        if (e.touches && e.touches[0] &&
            (Math.abs(e.touches[0].clientX - sx) > 10 || Math.abs(e.touches[0].clientY - sy) > 10)) {
          moved = true;
        }
      }, { passive: true });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (moved) return;
        var img = btn.querySelector('.pmg__img');
        var i = images.indexOf(img);
        open(list, i < 0 ? 0 : i);
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-pmg]').forEach(function (root) {
      initVideos(root);
      initGallery(root);
    });
  });
})();
